<template>
  <div class="bgimage"  :style="{ backgroundImage: 'url(' + src + ')' }">
      <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BackgroundImage',
  props: {
    src: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
   .bgimage{
       background-position: center center;
       background-size:cover;
       background-repeat: no-repeat;
   }
</style>
